import { render, staticRenderFns } from "./orgMessage.vue?vue&type=template&id=197b08ee&scoped=true&"
import script from "./orgMessage.vue?vue&type=script&lang=js&"
export * from "./orgMessage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/dialog.css?vue&type=style&index=0&id=197b08ee&prod&scoped=true&lang=css&"
import style1 from "../../assets/css/orgMessage.css?vue&type=style&index=1&id=197b08ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b08ee",
  null
  
)

export default component.exports